import { string } from 'zod';

export const URL_MATCHER = /^\/[^\n]+$/;
export const KEY_MATCHER = /[_a-z]+/;

const UUID_PATTERN = String.raw`[\da-f]{8}(?:-[\da-f]{4}){3}-[\da-f]{12}`;
export const UUID_MATCHER = new RegExp(`^${UUID_PATTERN}$`, 'i');

const BAID_PATTERN = String.raw`BA\d{5}`;
export const BAID_MATCHER = new RegExp(`^${BAID_PATTERN}$`);

const BSNID_PATTERN = String.raw`BSN\d{7}`;
export const BSNID_MATCHER = new RegExp(`^${BSNID_PATTERN}$`);

export const UUID_OR_BA_ID_OR_BSN_ID_MATCHER = new RegExp(`^(?:${UUID_PATTERN}|${BAID_PATTERN}|${BSNID_PATTERN})$`);

export const DATE_MATCHER = /^\d{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12]\d|3[01])$/;
export const TIME_MATCHER = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
export const REQUEST_ID_MATCHER = /^[\da-f]{8}(?:-[\da-f]{4}){3}-[\da-f]{12}$/i;
export const PASSWORD_MATCHER = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[!#$%&*?@^-]).{8,}$/;
export const REDIRECT_URIS_MATCHER = /^https:\/\//;
export const DOMAIN_MATCHER = /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

//✓ At least one letter per segment (no digit-only segments)
//✓ Dashes/underscores only between alphanumeric characters
//✓ At least one dot separator required
//✗ No double dots, trailing dots, or leading/trailing special characters

const scopeSegment = '(?=[a-z0-9_-]*[a-z])[a-z0-9]+(?:[_-][a-z0-9]+)*';
//Combines the segment pattern to form the full scope name. And ensures there is : separator followed by action segment.
export const SCOPE_NAME_MATCHER = new RegExp(`^${scopeSegment}(?:\\.${scopeSegment})+:${scopeSegment}$`);

export const serviceNowIdErrorMsg =
  'Provide valid Business application id (BAXXXXX) or Service offering id (BSNXXXXXXX)';
export const serviceNowIdentifierSchema = string()
  .regex(BAID_MATCHER, serviceNowIdErrorMsg)
  .or(string().regex(BSNID_MATCHER, serviceNowIdErrorMsg));
